/**
 * SVG Sprite Loader
 */
const __svg__ = { path: "../../node_modules/@vidazoo/ui/lib/assets/svg/*.svg", name: "assets/svg/logos.svg" };

(require("webpack-svgstore-plugin/src/helpers/svgxhr") as any)(__svg__);
